import './ThingsDraggable.svelte.css';
/* src/components/ThingsDraggable.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_animation,
	create_component,
	destroy_component,
	detach,
	element,
	fix_and_outro_and_destroy_block,
	fix_position,
	group_outros,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	set_store_value,
	space,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "../../_snowpack/pkg/svelte/internal.js";

import { flip } from "../../_snowpack/pkg/svelte/animate.js";
import { dndzone } from "../../_snowpack/pkg/svelte-dnd-action.js";
import { ThingTitle } from "./index.js";

import {
	svelteAnimateOptions,
	dndOptions,
	reorderItems
} from "../utils/dnd-helpers.js";

import { groupedThings } from "../stores/index.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	return child_ctx;
}

// (28:2) {#each dndItems as thing (thing.id)}
function create_each_block(key_1, ctx) {
	let div;
	let thingtitle;
	let t;
	let rect;
	let stop_animation = noop;
	let current;

	thingtitle = new ThingTitle({
			props: {
				thing: /*thing*/ ctx[6],
				category: /*category*/ ctx[0]
			}
		});

	return {
		key: key_1,
		first: null,
		c() {
			div = element("div");
			create_component(thingtitle.$$.fragment);
			t = space();
			attr(div, "class", "jd-thing jd-item-in-list svelte-2dosbk");
			toggle_class(div, "is-dragging", /*isDragging*/ ctx[2]);
			this.first = div;
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(thingtitle, div, null);
			append(div, t);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const thingtitle_changes = {};
			if (dirty & /*dndItems*/ 2) thingtitle_changes.thing = /*thing*/ ctx[6];
			if (dirty & /*category*/ 1) thingtitle_changes.category = /*category*/ ctx[0];
			thingtitle.$set(thingtitle_changes);

			if (dirty & /*isDragging*/ 4) {
				toggle_class(div, "is-dragging", /*isDragging*/ ctx[2]);
			}
		},
		r() {
			rect = div.getBoundingClientRect();
		},
		f() {
			fix_position(div);
			stop_animation();
		},
		a() {
			stop_animation();
			stop_animation = create_animation(div, rect, flip, svelteAnimateOptions);
		},
		i(local) {
			if (current) return;
			transition_in(thingtitle.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(thingtitle.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(thingtitle);
		}
	};
}

function create_fragment(ctx) {
	let section;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let dndzone_action;
	let current;
	let mounted;
	let dispose;
	let each_value = /*dndItems*/ ctx[1];
	const get_key = ctx => /*thing*/ ctx[6].id;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			section = element("section");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(section, "class", "jd-things svelte-2dosbk");
		},
		m(target, anchor) {
			insert(target, section, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(section, null);
			}

			current = true;

			if (!mounted) {
				dispose = [
					action_destroyer(dndzone_action = dndzone.call(null, section, {
						...dndOptions,
						items: /*dndItems*/ ctx[1],
						type: "THING"
					})),
					listen(section, "consider", /*handleConsiderThings*/ ctx[3]),
					listen(section, "finalize", /*handleFinalizeThings*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*isDragging, dndItems, category*/ 7) {
				each_value = /*dndItems*/ ctx[1];
				group_outros();
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].r();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, section, fix_and_outro_and_destroy_block, create_each_block, null, get_each_context);
				for (let i = 0; i < each_blocks.length; i += 1) each_blocks[i].a();
				check_outros();
			}

			if (dndzone_action && is_function(dndzone_action.update) && dirty & /*dndItems*/ 2) dndzone_action.update.call(null, {
				...dndOptions,
				items: /*dndItems*/ ctx[1],
				type: "THING"
			});
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $groupedThings;
	component_subscribe($$self, groupedThings, $$value => $$invalidate(5, $groupedThings = $$value));
	
	let { category } = $$props;
	let dndItems;
	let isDragging = false; // for styling

	const handleConsiderThings = e => {
		$$invalidate(2, isDragging = true);
		$$invalidate(1, dndItems = e.detail.items);
	};

	const handleFinalizeThings = e => {
		$$invalidate(2, isDragging = false);

		// @ts-ignore
		set_store_value(groupedThings, $groupedThings[category.id] = reorderItems(e.detail.items), $groupedThings);
	};

	$$self.$$set = $$props => {
		if ("category" in $$props) $$invalidate(0, category = $$props.category);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$groupedThings, category*/ 33) {
			$: $$invalidate(1, dndItems = $groupedThings ? $groupedThings[category.id] : []);
		}
	};

	return [
		category,
		dndItems,
		isDragging,
		handleConsiderThings,
		handleFinalizeThings,
		$groupedThings
	];
}

class ThingsDraggable extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { category: 0 });
	}
}

export default ThingsDraggable;